import { render, staticRenderFns } from "./LogChangesDialog.vue?vue&type=template&id=5315d07e&scoped=true"
import script from "./LogChangesDialog.vue?vue&type=script&lang=js"
export * from "./LogChangesDialog.vue?vue&type=script&lang=js"
import style0 from "./LogChangesDialog.vue?vue&type=style&index=0&id=5315d07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5315d07e",
  null
  
)

export default component.exports